import Snackbar from '../Snackbar';

export default class TextWithButton extends Snackbar {
  static templateId = 'text-with-button';

  static elements = ['detailsContainer', 'textContainer', 'buttonContainer'];

  constructor(...args) {
    super(...args);
    this.prepare();
  }

  prepare() {
    const { text, buttonText } = this.options;
    const buttonTextEl = this.buttonContainer.querySelector('.btn__text');

    this.textContainer.textContent = text;
    buttonTextEl.textContent = buttonText;

    return this;
  }
}
